import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const CONFIRM_SESSION = (id: Number, courseId: Number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-confirm-no`;

export type ConfirmNoSessionBody = {
  absentType: number;
  isUnit: boolean;
  courseId: number;
  id: number;
  halfSalary: number;
};

export type ConfirmSessionResponse = {
  session: Session;
};

export const confirmNoSession = ({
  absentType,
  isUnit,
  courseId,
  id,
  halfSalary,
}: ConfirmNoSessionBody) => {
  let params = {};
  if (isUnit) {
    params = { confirm: 1, 'absent-type': absentType, half_salary: halfSalary };
  } else {
    params = { confirm: 1 };
  }
  return httpClient.post<ConfirmSessionResponse>(
    CONFIRM_SESSION(id, courseId),
    params,
  );
};

export const useConfirmNoSession = (
  opts?: UseMutationOptions<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    ConfirmNoSessionBody
  >,
) =>
  useMutation<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    ConfirmNoSessionBody
  >(confirmNoSession, opts);
